<script setup lang="ts">
import crossIcon from '@/assets/icons/cross.svg';

import UiButtonIcon from '@/components/ui/UiButtonIcon.vue';
import UiText from '@/components/ui/UiText.vue';

interface Props {
  name: string;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  (event: 'clear'): void;
}>();
</script>

<template>
  <div class="beneficiary-info">
    <div class="beneficiary-info__body">
      <UiText class="beneficiary-info__label" size="lg" weight="medium">To</UiText>
      <button class="beneficiary-info__recipient" type="button" @click="emit('clear')">
        <UiText class="beneficiary-info__recipient-name" size="md" weight="medium">
          {{ props.name }}
        </UiText>
      </button>
      <UiButtonIcon
        class="beneficiary-info__clear-button"
        size="sm"
        :icon="crossIcon"
        mod="secondary"
        @click="emit('clear')"
      />
    </div>
  </div>
</template>

<style scoped>
.beneficiary-info {
  background-color: var(--color-background);
  border-radius: 0 0 12px 12px;
  box-shadow: var(--shadow-background-spread-md);
}

.beneficiary-info__body {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 64px;
  padding: 0 56px 0 16px;
  background-color: var(--color-main-underlay);
  border: none;
  border-radius: 12px;
}

.beneficiary-info__label {
  flex-shrink: 0;
  margin: 0 8px 0 0;
  user-select: none;
  pointer-events: none;
}

.beneficiary-info__recipient {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: auto;
  min-width: 0;
  height: 28px;
  margin: 0;
  padding: 0 8px;
  color: inherit;
  text-align: left;
  background-color: var(--color-secondary-contrast);
  border: none;
  border-radius: 14px;
  cursor: pointer;
  appearance: none;
  user-select: none;
}

.beneficiary-info__recipient-name {
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.beneficiary-info__network {
  position: absolute;
  top: 8px;
  right: 0;
}

.beneficiary-info__clear-button {
  position: absolute;
  top: calc(50% - 12px);
  right: 16px;
  transition: opacity var(--animation-micro) var(--animation-effect);
}
</style>
